import Axios from "@/plugins/Axios";

export class PresencasService {
  async getPresencasHikvision({ matricula_id, data = null, evento = null }) {
    const params = { matricula_id };

    if (data) params.data = data;
    if (evento !== null && evento !== undefined && evento !== "") params.evento = evento;

    const response = await Axios().get("notifiq/presencas/presencas-hikvision", { params });
    return response.data;
  }

  async getPresencasNotifiqHikvision(dateOrPayload, horario_id = null, turma_id = null) {
    const payload =
      typeof dateOrPayload === "object"
        ? dateOrPayload
        : { date: dateOrPayload, horario_id, turma_id };

    if (!payload.date || !payload.horario_id || !payload.turma_id) {
      throw new Error("Parâmetros insuficientes: date, horario_id e turma_id são necessários.");
    }

    try {
      const response = await Axios().post("notifiq/presencas/get-presencas-hikvision", payload, {
        timeout: 15000, // 15s - ajusta se necessário
      });
      return response.data;
    } catch (err) {
      // Normaliza mensagens de erro para o componente tratar
      if (err.response) {
        const msg = err.response.data?.message || `Erro ${err.response.status}`;
        throw new Error(`Importação Hikvision falhou: ${msg}`);
      } else if (err.request) {
        throw new Error("Sem resposta do servidor ao tentar importar do Hikvision (timeout/rede).");
      } else {
        throw new Error(`Erro ao importar do Hikvision: ${err.message}`);
      }
    }
  }

  async listPresencasNotifiq() {
    const response = await Axios().get("notifiq/presencas");
    return response.data;
  }
}
export default new PresencasService();
